/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRoleDto
 */
export interface CreateRoleDto {
    /**
     * 
     * @type {string}
     * @memberof CreateRoleDto
     */
    name: string;
}

/**
 * Check if a given object implements the CreateRoleDto interface.
 */
export function instanceOfCreateRoleDto(value: object): value is CreateRoleDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateRoleDtoFromJSON(json: any): CreateRoleDto {
    return CreateRoleDtoFromJSONTyped(json, false);
}

export function CreateRoleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRoleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function CreateRoleDtoToJSON(json: any): CreateRoleDto {
    return CreateRoleDtoToJSONTyped(json, false);
}

export function CreateRoleDtoToJSONTyped(value?: CreateRoleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

